import React from 'react'
import { Link } from 'react-router-dom'

import { ARCHIVED_NOTES } from 'data/filters/types'
import RoutesHelper from 'helpers/RoutesHelper'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

import { ArchivedNoteControls } from './Controls'
import NoteIconWithPicker from '../NoteIconWithPicker'
import { useDispatch } from 'react-redux'
import { trackNoteClicked } from '../../../../../data/analytics/actions'
import { ExpandableRowLayout } from '../ExpandableRowLayout'

export type ArchivedNoteProps = {
  id: string
  depth: number
  isActive: boolean
  isExpandable: boolean
  onToggleExpand: (noteId: string) => void
  isExpanded: boolean
  title: string
  iconShape: string
  iconColor: string
}

export const ArchivedNoteItem = ({
  id,
  depth,
  isActive,
  isExpandable,
  onToggleExpand,
  isExpanded,
  title,
  iconShape,
  iconColor,
}: ArchivedNoteProps) => {
  const dispatch = useDispatch()
  const [isMorePopoverOpen, setMorePopoverIsOpen] = React.useState(false)

  const handleClick = () =>
    dispatch(trackNoteClicked({ source: 'structure-archived' }))

  return (
    <ExpandableRowLayout
      id={id}
      onToggleExpand={onToggleExpand}
      disableExpanding={!isExpandable}
      isExpanded={isExpanded}
      onClick={handleClick}
      renderComponent={props => (
        <TooltipOnHover
          id={`tooltip-sidebar-${id}`}
          tooltipContent={title}
          placement="right"
          delayShow={1000}
        >
          <Link
            {...props}
            to={RoutesHelper.noteFilterShow({
              filterId: ARCHIVED_NOTES.get('id'),
              noteId: id,
            })}
          />
        </TooltipOnHover>
      )}
      className="child-effects-on-hover"
      depth={depth}
      label={title || 'Untitled'}
      isActive={isActive}
      icon={
        <NoteIconWithPicker
          noteId={id}
          iconShape={iconShape}
          iconColor={iconColor}
        />
      }
      rightPart={
        <ArchivedNoteControls
          className={
            isMorePopoverOpen ? '' : 'opacity-null opaque-child-effect'
          }
          noteId={id}
          onMorePopoverIsOpenChange={setMorePopoverIsOpen}
        />
      }
    />
  )
}
